module.exports = __webpack_public_path__ + "img/ES1490.ee402708.png";